import { Memberships } from "../components/Memberships";
import { FadeIn } from "../components/FadeIn";
import { BOOKING_URL, MEMBERSHIP_BENEFITS } from "../data/content";
import { Crown, CheckCircle2, ShieldCheck, Zap } from "lucide-react";

export const MembershipsPage = () => {
  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-extrabold mb-3 flex justify-center items-center gap-1.5">
            <Crown className="w-4 h-4" /> VIP Privilege Program
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-600 mb-6">
            Hammam VIP Membership Tiers
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Elevate your wellness journey with our prepaid wallet credits. Enjoy up to ₹15,000 extra bonus value, priority booking, free jacuzzi upgrades & exclusive member privileges.
          </p>
        </FadeIn>
      </div>

      <Memberships />

      {/* Benefits Breakdown */}
      <div className="max-w-4xl mx-auto mt-20 pt-16 border-t border-white/10">
        <FadeIn>
          <h2 className="text-2xl sm:text-3xl font-serif text-amber-400 font-bold mb-8 text-center">
            All Membership Perks & Privileges
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-[#0c0c0c] border border-amber-400/40 p-8 rounded-3xl">
            {MEMBERSHIP_BENEFITS.concat([
              "No expiration date on your prepaid wallet balance",
              "Transferable credits for guest visits & friends",
              "Complimentary express facility check-in",
              "Exclusive invitations to special VIP wellness events",
            ]).map((benefit, idx) => (
              <div key={idx} className="flex items-start gap-3 text-sm text-white/90">
                <CheckCircle2 className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
                <span>{benefit}</span>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black font-extrabold px-10 py-4 rounded-full text-xs uppercase tracking-[0.2em] shadow-lg hover:scale-105 transition-transform"
            >
              Apply For VIP Membership
            </a>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};
